/**
 * Formats a transport mode string for UI display.
 * - Renames "transshipment" to "HUB"
 * - Renames "truck" to "ROAD"
 * - Uppercases the result
 */
export const formatTransportMode = (mode: string): string => {
  const normalized = mode.toLowerCase().trim();
  if (normalized === 'transshipment') return 'HUB';
  if (normalized === 'truck') return 'ROAD';
  return mode.toUpperCase();
};
